const Testimonials = () => {
  const testimonials = [
    {
      quote: "I was terrified to do this without an agent. REALV3 walked me through every single step. I never felt alone — and I never paid someone $18,000 to hold my hand.",
      initials: "MR",
      name: "Maria R.",
      detail: "Sold in Miami, FL · 22 days",
      saved: "Saved $21,600",
    },
    {
      quote: "As a buyer I negotiated directly with the seller. We both saved money. The seller dropped the price because they weren't paying a listing agent. This should have always existed.",
      initials: "JT",
      name: "James T.",
      detail: "Bought in Orlando, FL · First-time buyer",
      saved: "Saved $14,200",
    },
    {
      quote: "I've sold three investment properties through REALV3. The savings compound. By the third sale I knew the process cold. The platform gets better every time you use it.",
      initials: "DL",
      name: "David L.",
      detail: "Sold 3 properties · Tampa, FL",
      saved: "Saved $67,000",
    },
    {
      quote: "The attorney review feature gave me complete peace of mind. I paid $300 for an hour of real estate legal guidance instead of $12,000 for an agent. That math is not complicated.",
      initials: "SC",
      name: "Sofia C.",
      detail: "Sold in Fort Lauderdale, FL · 31 days",
      saved: "Saved $19,800",
    },
  ];

  return (
    <section className="bg-brand-teal-800 py-20 px-6">
      <div className="max-w-[960px] mx-auto">
        <p className="text-xs font-bold text-brand-teal-200 uppercase tracking-widest mb-3">
          Real people. Real savings.
        </p>
        <h2
          className="text-3xl md:text-4xl font-bold text-white mb-3"
          style={{ lineHeight: '1.2', letterSpacing: '-0.5px' }}
        >
          The community is already building.
        </h2>
        <p className="text-base text-brand-teal-200 leading-relaxed max-w-[560px] mb-10">
          These are the people who decided their home sale belonged to them.
        </p>

        <div className="grid md:grid-cols-2 gap-4">
          {testimonials.map((t) => (
            <div
              key={t.initials}
              className="bg-white/[0.07] rounded-2xl p-6 border border-white/[0.12]"
            >
              <p className="text-sm text-secondary italic leading-relaxed mb-5">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center text-xs font-bold text-primary-foreground flex-shrink-0">
                  {t.initials}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-brand-teal-200">{t.detail}</p>
                </div>
                <p className="text-sm font-bold text-accent ml-auto whitespace-nowrap">
                  {t.saved}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
